module.exports = __webpack_public_path__ + "static/media/Formlabs.bab93f0e.png";